import { palette } from '../palette';
import { lighten, darken } from '@mui/material';
import lightOrdarkColor from "@check-light-or-dark/color";

const MuiPagination = {
  styleOverrides: {
     root: ({theme} : any) => ({
      '& .MuiPaginationItem-root': {     
        borderColor: theme.palette.primary.main,
        fontWeight: 600,
        borderRadius: '8px',

        '&:hover': {
          color: theme.palette.primary.main,
          backgroundColor: lighten(theme.palette.primary.main,0.86),
        },

        '&.Mui-selected': {
          color: palette.primary.contrastText,
          backgroundColor: theme.palette.primary.main,//palette.primary.main,
          borderColor: theme.palette.primary.main,//palette.primary.main,

          '&:hover': {
            color: theme.palette.primary.main,//palette.primary.main,
            backgroundColor: lighten(theme.palette.primary.main,0.86),//palette.primary.dark,
          },
        },

        '& .MuiSvgIcon-root': {
          color: theme.palette.primary.main,//palette.primary.main,
        },
      },
      '& .MuiPaginationItem-previousNext': {
        color:  theme.palette.primary.main,//palette.primary.main,
        borderColor:  theme.palette.primary.main,//palette.primary.main,

        '&:hover': {
          color: theme.palette.primary.main,//palette.primary.main,
          backgroundColor:  lighten(theme.palette.primary.main,0.86),//palette.primary.dark,,
        },
      },
    }),
  },
};

export default MuiPagination;
